import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import {
  FixedFeeRelatedTerm as FixedFeeRelatedTermItem,
  FixedFeeTerm,
} from '../../../../../../../../store/fixedFee/types';

import { FixedFeeRelatedTermDesktop } from './desktop';
import { FixedFeeRelatedTermMobile } from './mobile';

export interface FixedFeeRelatedTermProps {
  fixedFeeTerm: FixedFeeTerm;
}

export interface FixedFeeRelatedTermContentProps {
  relatedTerm: FixedFeeRelatedTermItem;
}

export const FixedFeeRelatedTerm: React.FC<FixedFeeRelatedTermProps> = ({ fixedFeeTerm }) => {
  const relatedTerm = fixedFeeTerm.relatedTerm;

  const element = useBreakpointValue({
    base: relatedTerm ? <FixedFeeRelatedTermMobile relatedTerm={relatedTerm} /> : null,
    sm: relatedTerm ? <FixedFeeRelatedTermMobile relatedTerm={relatedTerm} /> : null,
    lg: relatedTerm ? <FixedFeeRelatedTermDesktop relatedTerm={relatedTerm} /> : null,
  });

  if (!relatedTerm) {
    return null;
  }

  return element;
};
